// Pain Signal Scoring Configuration
// Scores determine lead quality tier and campaign key routing

// Score values for Q1: Pain signals (multi-select, cumulative)
export const PAIN_SIGNAL_SCORES = {
  missed_payment: 15,
  minimums_only: 10,
  collection_contact: 15,
  robbing_peter: 20
}

// Score values for Q2: How often think about debt
export const WORRY_FREQUENCY_SCORES = {
  constantly: 15,
  daily: 10,
  sometimes: 5,
  rarely: 0
}

// Score values for Q3: Main barrier
export const BARRIER_SCORES = {
  tried_failed: 15,
  dont_know_start: 10,
  too_many_accounts: 5,
  interest_too_high: 5,
  income_too_low: 5
}

// Score values for Q4: Debt amount
export const DEBT_AMOUNT_SCORES = {
  over_20k: 20,
  '15k_20k': 15,
  '10k_15k': 10,
  under_10k: 5
}

// Debt amount values (for verified_debt)
export const DEBT_AMOUNT_VALUES = {
  over_20k: 25000,
  '15k_20k': 17500,
  '10k_15k': 12500,
  under_10k: 7500
}

// Score tier thresholds
export const SCORE_TIERS = {
  hot: 60,    // 60+ = hot
  warm: 40,   // 40-59 = warm
  cool: 20    // 20-39 = cool
  // Below 20 = cold
}

// Get tier from score
export function getScoreTier(score) {
  if (score >= SCORE_TIERS.hot) return 'hot'
  if (score >= SCORE_TIERS.warm) return 'warm'
  if (score >= SCORE_TIERS.cool) return 'cool'
  return 'cold'
}

// Calculate total pain score
export function calculatePainScore({
  painSignals = [],      // Array of selected pain signal keys
  worryFrequency = null, // Key from WORRY_FREQUENCY_SCORES
  barrier = null,        // Key from BARRIER_SCORES
  debtAmount = null      // Key from DEBT_AMOUNT_SCORES
}) {
  let score = 0

  // Q1: Pain signals (cumulative)
  painSignals.forEach(signal => {
    score += PAIN_SIGNAL_SCORES[signal] || 0
  })

  // Q2: Worry frequency
  if (worryFrequency && WORRY_FREQUENCY_SCORES[worryFrequency] !== undefined) {
    score += WORRY_FREQUENCY_SCORES[worryFrequency]
  }

  // Q3: Barrier
  if (barrier && BARRIER_SCORES[barrier] !== undefined) {
    score += BARRIER_SCORES[barrier]
  }

  // Q4: Debt amount
  if (debtAmount && DEBT_AMOUNT_SCORES[debtAmount] !== undefined) {
    score += DEBT_AMOUNT_SCORES[debtAmount]
  }

  return score
}
